$ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var ProductFilters = function () {
	this.$filtersUl = $( document.getElementById( 'product-filters' ) );
	this.$filterLinks = $( document.getElementsByClassName( 'product-filter' ) );
	this.$filterParent = $( document.getElementsByClassName( 'filters-parent' ) );
	this.$productUl = $( document.querySelector( 'ul.products' ) );
	this.$mobileBtn = $( document.getElementById( 'filters-btn' ) );
	this.$closeBtn = $( document.getElementById( 'close-filters' ) );
	this.filterSlug = '';
	this.title = '';
	this.selections = new Array( this.initial_title );
	this.is_search = big_ajax.s;
	if ( this.is_search != '' ) {
		this.initial_title = '<a href="'+ big_ajax.shop_url +'?s='+ this.is_search +'">SØKERESULTATER: “'+ this.is_search +'”</a>';
	} else {
		this.initial_title = '<a href="'+ big_ajax.shop_url +'">Butikk</a>';
	}
};

ProductFilters.prototype.init = function () {
	var self = this,
		slug;

	if ( $( 'body.archive.tax-product_cat' ).length > 0 ) {
		$('#product-filters .facetwp-checkbox[data-value='+ $( 'body' ).data( 'product-cat-slug' ) +']').addClass( 'checked' );
		FWP.refresh();
	}

	// if the category facet is already set, add the needed classes on the category menu
	if ( typeof FWP !== 'undefined' && Object.keys(FWP).includes('facets') && FWP.facets['big_categories'] && FWP.facets['big_categories'].length > 0 ) {
		$( '#product-filters a.product-filter[data-cat-slug="'+ FWP.facets['big_categories'][0] +'"]' ).closest( 'li' ).addClass( 'chosen' );
		$( '#product-filters a.product-filter[data-cat-slug="'+ FWP.facets['big_categories'][0] +'"]' ).closest( 'ul.child-terms' ).addClass( 'open' );
	}

	$(document).on( 'facetwp-refresh', function() {
        $( '.facetwp-template' ).fadeTo( 0, 0.3 ).addClass( 'refreshing' );

    });
    $(document).on( 'facetwp-loaded', function() {
        $( '.facetwp-template' ).fadeTo( 0, 1 ).removeClass( 'refreshing' );
    });

	$(window).on('load', function() {
		// FWP.refresh();
		self.filter_categories();
    });


	$(function() {
        FWP.hooks.addAction( 'facetwp/refresh', function() {
			// self.filter_categories();
        }, 10);
    });

	$(function() {
		FWP.hooks.addAction( 'facetwp/loaded', function() {
			self.filter_categories();
        }, 20);
    });

	// Handle the click action on the filter itself
	self.$filterLinks.click( function ( e ) {

		e.preventDefault();

		// If we're clearing filters
		if ( $( this ).closest( 'li' ).hasClass( 'chosen' ) ) {

			// Remove chosen and disabled classes from all the filters and show the counts
			self.$filterLinks.closest( 'li' ).removeClass( 'chosen' );
			$( '.cat-filter-wrap .child-terms li' ).removeClass( 'disabled' );
			$( '.cat-filter-wrap .child-terms li .count' ).show();

			self.filterSlug = '';

			$( '#product-filters .facetwp-checkbox' ).removeClass( 'checked' );

			FWP.refresh();


		} else { // Else, filter

			// Clear the chosen classes, then add it to the selected filter, fading other filters and hiding their counts
			self.$filterLinks.closest( 'li' ).removeClass( 'chosen' );
			$( this ).closest( 'li' ).toggleClass( 'chosen' ).removeClass( 'disabled' );
			$( '.cat-filter-wrap .child-terms li:not(.chosen)' ).addClass( 'disabled' );
			// $( '.cat-filter-wrap .child-terms li:not(.chosen) .count' ).hide();

			self.filterSlug = this.dataset.catSlug;
			self.title = this.innerHTML;

			// $('.facetwp-facet-big_brands .facetwp-radio').removeClass('checked');
			// $('.facetwp-facet-big_series .facetwp-radio').removeClass('checked');

			var is_checked = $('#product-filters .facetwp-checkbox[data-value='+self.filterSlug+']').hasClass('checked');
			$('#product-filters .facetwp-checkbox').removeClass('checked');
			is_checked ? $('#product-filters .facetwp-checkbox[data-value='+self.filterSlug+']').removeClass('checked') : $('#product-filters .facetwp-checkbox[data-value='+self.filterSlug+']').addClass('checked');

			FWP.refresh();

			self.refresh_category_count();

		}

		self.filterSlug = '';
	} );
};


ProductFilters.prototype.refresh_category_count = function () {

	$(document).on('facetwp-loaded', function() {
		$( '.cat-filter-wrap .chosen .count' ).html( FWP.settings.pager.total_rows ).show();
	});
};

// show / hide categories according to the selected filters
ProductFilters.prototype.filter_categories = function () {

	var self = this;

	// if we are on a category archive and no category is chosen, then select it
	if ( $( 'body.archive.tax-product_cat' ).length > 0 && FWP.facets['big_categories'].length == 0 ) {
		$('#product-filters .facetwp-checkbox[data-value='+ $( 'body' ).data( 'product-cat-slug' ) +']').addClass( 'checked' );
		FWP.refresh();
		return;
	}

	// hide all categories
	$( '.dk-wcan.categories .cat-filter-wrap' ).hide();
	$( '.dk-wcan.categories .cat-filter-wrap ul.child-terms li' ).hide();

	// remove chosen
	$( 'ul.child-terms li.chosen' ).removeClass( 'chosen' );

	// close all categories parent menus
	if ( $( '.child-terms.open' ).length > 0 ) {
		$( '#product-filters .child-terms.open' ).removeClass('open');
	}

	// unless it is a brand archive page, so open all 2 level categories
	if ( $( 'body.archive.tax-product_brand' ).length > 0 ) {
		$( '#product-filters .child-terms' ).addClass('open');
	}

	self.selections = [ self.initial_title ];



	$( '.fwp-categories .facetwp-checkbox:not(.disabled)' ).each(function () {
		if ($( '#product-filters a[data-cat-slug="'+ $(this).data('value') +'"]' ).length > 0) {
			$( '#product-filters a[data-cat-slug="'+ $(this).data('value') +'"]' ).closest( 'li' ).show();
			$( '#product-filters a[data-cat-slug="'+ $(this).data('value') +'"] span.count' ).text($(this).find('span.facetwp-counter').text()); // update the count
			$( '#product-filters a[data-cat-slug="'+ $(this).data('value') +'"]' ).closest( 'li.cat-filter-wrap' ).show();
			if ( $( '.facetwp-facet-big_brands .facetwp-radio.checked' ).length > 0 || $( '.facetwp-facet-big_series .facetwp-radio.checked' ).length > 0 ) {
				$( '#product-filters a[data-cat-slug="'+ $(this).data('value') +'"]' ).closest( 'ul.child-terms' ).addClass( 'open' );
			}
		} else {
			// categories filters are not active
		}

		if ( $( this ).hasClass( 'checked' ) ) {
			$( '#product-filters a[data-cat-slug="'+ $(this).data('value') +'"]' ).closest( 'ul.child-terms' ).addClass( 'open' );
			$( '#product-filters a[data-cat-slug="'+ $(this).data('value') +'"]' ).closest( 'li' ).addClass( 'chosen' );


			if ( $( '#product-filters a.product-filter[data-cat-slug="'+ $(this).data('value') +'"]' ).hasClass( 'main-product-filter' ) ) {
				$( '#product-filters a.product-filter[data-cat-slug="'+ $(this).data('value') +'"]' ).closest( '.cat-filter-wrap.chosen' ).closest( 'ul.child-terms' ).addClass( 'open' );
			}

			// if this is a child category, add its parent
			if ( $( '.product-filter[data-cat-slug="'+ $(this).data('value') +'"]' ).closest( 'li' ).hasClass( 'level-1' ) ) {

				self.selections.push( '<a href="'+ $( '.product-filter[data-cat-slug="'+ $(this).data('value') +'"]' ).closest( 'li.cat-filter-wrap' ).find( 'h2.parent-cat a' ).attr( 'href' ) +'">'+ $( '.product-filter[data-cat-slug="'+ $(this).data('value') +'"]' ).closest( 'li.cat-filter-wrap' ).find( 'h2.parent-cat>a>span' ).contents().filter(function() { return this.nodeType == 3; }).text().trim() +'</a>' );

			}

			self.selections.push( '<a href="'+ $( '.product-filter[data-cat-slug="'+ $(this).data('value') +'"]' ).attr( 'href' ) +'">'+ $(this).contents().filter(function() { return this.nodeType == 3; }).text().trim() +'</a>' );

		}

		if ( $( 'body.archive.post-type-archive-product' ).length > 0 || $( 'body.archive.tax-product_cat' ).length > 0 ) {
			$( 'h1.page-title' ).html( self.selections.join( '<span class="title_join"></span>' ) );
			$( '.mobile-page-title' ).html( self.selections[ self.selections.length-1 ] );
		}

	});

	// open active categories parent menu

	if ( $( '#product-filters .chosen' ).length > 0 ) {
		$( '#product-filters .chosen' ).closest( 'ul.child-terms' ).addClass( 'open' );

		if ( $( '#product-filters .chosen' ).hasClass( 'cat-filter-wrap' ) ) {
			$( '#product-filters .chosen' ).find( 'ul.child-terms' ).addClass( 'open' );
		}
	}


};


ProductFilters.prototype.mobile_button = function () {

	var self = this;

	self.$mobileBtn.click( function ( e ) {
		e.preventDefault();

		self.$filtersUl.add( '#veil' ).addClass( 'open' );
		$( '.filtered-wrapper > nav' ).addClass( 'open' );
		$( 'html, body' ).addClass( 'disable-scroll' );
	} );

	self.$closeBtn.add( '#veil' ).click( function ( e ) {
		e.preventDefault();
		self.$filtersUl.add( '#veil' ).removeClass( 'open' );
		$( '.filtered-wrapper > nav' ).removeClass( 'open' );
		$( 'html, body' ).removeClass( 'disable-scroll' );
	} );
};

module.exports = new ProductFilters();
